/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';

export const bootstrap = (state = defaultState.bootstrap, action) => {
    let nextState = Utilities.deepClone(state);

    if (action.type === constants.APP_READY) {
        if (action.status === constants.STATE_SUCCESS) {
            nextState.configLoaded = true;
            nextState.isClient = action.payload.isClient;
        }
    }

    return nextState;

};
